export default "__VITE_ASSET__e0fc29a7__"